import { useState } from 'react';
import { createTableStore } from '@/components/table/contexts/tableStore.ts';
import { ListSearch } from '@/components/table/routes/listSearchParams.ts';

export const useCreateTableStore = ({
  pageSize,
  listSearch,
}: {
  pageSize: number;
  listSearch?: ListSearch;
}) => {
  const [store] = useState(() =>
    createTableStore({
      pageSize,
      searchTerm: listSearch?.query,
      quickFilters: listSearch?.quick,
      urlFilters: listSearch?.filters,
    }),
  );
  return store;
};
